var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommOpenRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14712_6944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61889 8.22046C6.61781 8.22046 6.6166 8.22046 6.61552 8.22046C6.2372 8.22046 5.88137 8.36793 5.61269 8.63595C5.34104 8.90693 5.19141 9.26774 5.19141 9.65184V31.1152C5.19141 31.9023 5.83424 32.5442 6.62454 32.5462C9.95627 32.5541 15.5382 33.2486 19.389 37.2783V14.8163C19.389 14.5495 19.3209 14.2989 19.1923 14.0915C16.0317 9.00161 9.95816 8.22827 6.61889 8.22046Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8088 31.1151V9.6516C35.8088 9.26749 35.6592 8.90668 35.3875 8.6357C35.1188 8.36769 34.7628 8.22021 34.3848 8.22021C34.3836 8.22021 34.3824 8.22021 34.3813 8.22021C31.0422 8.22816 24.9686 9.0015 21.808 14.0913C21.6793 14.2988 21.6113 14.5494 21.6113 14.8162V37.2781C25.4621 33.2483 31.0441 32.5539 34.3758 32.546C35.166 32.5439 35.8088 31.902 35.8088 31.1151Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0688 13.1702H38.031V31.1151C38.031 33.1247 36.3936 34.7634 34.381 34.7684C31.555 34.7751 26.8953 35.3277 23.5952 38.4511C29.3027 37.0536 35.3194 37.962 38.7484 38.7435C39.1765 38.841 39.619 38.7402 39.962 38.4668C40.3038 38.1941 40.4999 37.7864 40.4999 37.3488V14.6013C40.5001 13.8122 39.8579 13.1702 39.0688 13.1702Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96896 31.1151V13.1702H1.93112C1.14216 13.1702 0.5 13.8122 0.5 14.6013V37.3484C0.5 37.7861 0.696095 38.1937 1.03791 38.4664C1.38068 38.7397 1.8227 38.8408 2.25152 38.743C5.68049 37.9615 11.6973 37.0532 17.4046 38.4507C14.1046 35.3274 9.44495 34.775 6.61894 34.7682C4.60641 34.7634 2.96896 33.1247 2.96896 31.1151Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14712_6944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommOpenRate);
export default __webpack_public_path__ + "static/media/comm_open_rate.e61603e4824cecf3bdff7fdfcb2874d2.svg";
export { ForwardRef as ReactComponent };